'use client'

import { format, subMonths } from 'date-fns'
import { PeriodSelector } from '@/components/ui/analytics/period-selector'
import type { AdminTenantPeriod, AdminTenantPeriodPreset } from '@/lib/billing/admin-tenant-period'
import { useTranslations } from "next-intl"



export function TenantBillingPeriodFilter({ period, onChange }: {
  period: AdminTenantPeriod
  onChange: (period: AdminTenantPeriod) => void
}) {

  const tUi = useTranslations("Billing.BillingTenantBillingPeriodFilter")

  const previousMonth = format(subMonths(new Date(), 1), 'MMM')
  const options: { value: AdminTenantPeriodPreset; label: string }[] = [
    { value: 'this_month', label: tUi("thisMonth") },
    { value: 'previous_month', label: `Previous Month (${previousMonth})` },
    { value: 'today', label: tUi("today") },
  ]

  function changePeriod(next: AdminTenantPeriod['period'], customRange?: { from: string; to: string }) {
    if (next === 'custom') {
      if (!customRange) return
      onChange({ period: next, ...customRange })
      return
    }
    onChange({ period: next })
  }

  return (
    <div
      role="group" aria-label={tUi("billingPeriod")}
      className="flex min-w-0 max-w-full flex-wrap items-center gap-x-4 gap-y-2 rounded-lg border border-amber-200/60 bg-amber-50/40 px-3 py-2 dark:border-amber-900/40 dark:bg-amber-950/20"
    >
      <p className="text-xs font-medium"><span key={tUi("platformPaidRevenueCostProfitMargin")}>{tUi("platformPaidRevenueCostProfitMargin")}</span></p>
      <PeriodSelector<AdminTenantPeriod['period']>
        period={period.period}
        customRange={period.period === 'custom' ? period : null}
        onPeriodChange={changePeriod}
        options={options}
        allowSingleDay
        className="max-w-full"
        triggerClassName="min-w-0 w-[220px] max-w-full flex-1"
      />
      <span className="text-xs text-muted-foreground"><span key={tUi("eachTenantSTimezone")}>{tUi("eachTenantSTimezone")}</span></span>
    </div>
  )
}
